<template>
  <div class="toggle" :class="{ 'out-header': outHeader }">
    <div class="wrapper">
      <div
        :class="{
          _active: page === 'home',
        }"
        @click="$router.push('/')"
      >
        Списком
      </div>
      <div
        :class="{
          _active: page === 'map' || page === 'map/:catId',
        }"
        @click="$router.push(`/map`)"
      >
        На карте
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/css/bundle";

export default {
  name: "MainViewToggle",

  props: {
    outHeader: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    page() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped lang="scss">
.toggle {
  height: 48px;

  .wrapper {
    display: flex;
    align-items: center;
    background-color: #fef6e8;
    gap: 8px;
    padding: 4px;
    border-radius: 100px;

    width: 205px;
    height: 48px;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
      height: 38px;
      width: 164px;
      background-color: #fef6e8;

      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #f18e35;
      border-radius: 100px;
      cursor: pointer;

      &:first-child {
        width: 94px;
        flex: 0 0 auto;
      }
      &._active {
        background-color: #f18e35;
        color: #fff;

        box-shadow: 0 4px 16px 0 #f18e3529;
      }
    }
  }

  &.out-header {
    .wrapper {
      width: 100%;
      background-color: #fff;

      div {
        width: 156px;
        flex: 0 0 auto;
        background-color: #fff;
        &._active {
          background-color: #f18e35;
          color: #fff;

          box-shadow: 0 4px 16px 0 #f18e3529;
        }
      }
    }
  }
}
</style>
